document.addEventListener("scroll", function () {
  const nav1 = document.querySelector(".headerV1__nav");
  const nav2 = document.querySelector(".headerV2__nav");
  const nav3 = document.querySelector(".headerV3__nav");
  let currentNav = null;

  if (nav1 !== null) currentNav = nav1;
  if (nav2 !== null) currentNav = nav2;
  if (nav3 !== null) currentNav = nav3;

  if (currentNav !== null) {
    const logo = document.querySelector(".newHeaderNav__logo img");
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;

    if (scrollPosition > window.innerHeight) {
      // Проверяем, прокручена ли страница больше чем 100vh
      logo.src = "/assets/images/logo_header.svg";
      currentNav.classList.add("fixed");

    } else {
      currentNav.classList.remove("fixed");
      logo.src = "/assets/images/header/logo.png";
    }
  }
});
